export const messages = {
  en: {
    affiliateVisitManage: {
      queryCondition: 'Query Condition',
      selectVisitRecord: 'Please select affiliate visit record',
      query: 'Query',
      visitRecord: 'Visit Records',
      visitId: 'Visit ID',
      affiliateId: 'Affiliate ID',
      visitorId: 'Visitor ID',
      userId: 'User ID',
      ipAddress: 'IP Address',
      deviceId: 'Device ID',
      userAgent: 'User Agent',
      landingPage: 'Landing Page',
      createTime: 'Create Time',
      operation: 'Operation',
      delete: 'Delete'
    },
    deleteAffiliateVisit: {
      confirmOperation: 'Please confirm your operation!',
      confirmDeleteVisitRecord: 'Confirm to delete affiliate visit record?',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete!',
      deleteSuccess: 'Delete successfully',
      deleteFailed: 'Delete failed'
    }
  },
  zh: {
    affiliateVisitManage: {
      queryCondition: '查询条件',
      selectVisitRecord: '请选择分销访问记录',
      query: '查询',
      visitRecord: '访问记录',
      visitId: '访问ID',
      affiliateId: '分销员ID',
      visitorId: '访客ID',
      userId: '用户ID',
      ipAddress: 'IP地址',
      deviceId: '设备ID',
      userAgent: 'UserAgent',
      landingPage: '落地页',
      createTime: '创建时间',
      operation: '操作',
      delete: '删除'
    },
    deleteAffiliateVisit: {
      confirmOperation: '请确认您的操作!',
      confirmDeleteVisitRecord: '确定删除分销访问记录?',
      cancel: '点错了',
      confirmDelete: '确认删除!',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败'
    }
  }
}